<template>
  <div class="student-evolution navigation-top-app">
    <navigation-top-app
      v-if="report.selected.license === ''"
      :app="app"
      :menu-screen="app.user.role === 'student'"
      :back="() => {
        $router.push({name: 'app.student.profile', params: {code: this.student.data.code}, query: {origin: 'app', navigationLeft: 'false', token: app.token}})
      }"
    >
      <template v-slot:center>
        <div id="navigation-center">
          {{ app.strings.app.student.dgtreport.title }}
        </div>
      </template>
    </navigation-top-app>
    <navigation-top-app
      v-if="report.selected.license !== '' && report.selected.test === -1"
      :app="app"
      :back="closeTests"
    >
      <template v-slot:center>
        <div id="navigation-center">
          {{ app.strings.app.student.dgtreport.title }} · {{ app.strings.app.student.dgtreport.license.replace('{l}', report.selected.license) }}
        </div>
      </template>
    </navigation-top-app>
    <transition name="fade">
      <div id="student-dgtreport-content" v-if="show && !loading">
        <div class="dgt-column">
          <div class="dgt-empty" v-if="report.licenses.length === 0">
            <font-awesome-icon :icon="['far', 'file']" />
            <span>{{ app.strings.app.student.dgtreport.no_classes }}</span>
          </div>
          <template v-else>
            <p class="dgt-hint" v-if="report.selected.license === ''">{{ app.strings.app.student.dgtreport.choose_license }}</p>
            <p class="dgt-hint" v-else-if="report.selected.test === -1">{{ app.strings.app.student.dgtreport.choose_test }}</p>
            <list :app="app" :items="licenses" :index="'value'" :value="'name'" @onSelect="(license) => {
              selectLicense(license.value)
            }" v-if="report.selected.license === ''" />
            <list :app="app" :items="tests" :index="'value'" :value="'name'" @onSelect="(test) => {
              report.selected.test = test.value
              openReport()
            }" v-if="report.selected.license !== '' && report.selected.test === -1" />
            <div class="dgt-about">
              <font-awesome-icon :icon="['far', 'file']" />
              <div>
                <b>{{ app.strings.app.student.dgtreport.about.title }}</b>
                <p>{{ app.strings.app.student.dgtreport.about.text }}</p>
                <p>{{ app.strings.app.student.dgtreport.about.circuit }}</p>
              </div>
            </div>
          </template>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div id="student-dgtreport-content" v-if="show && loading">
        <loader-dot :size="'16px'" :color_1="'rgb(32, 113, 183)'" :color_2="'rgb(32, 113, 183)'" />
      </div>
    </transition>

    <student-dgt-report-component ref="student-report" :app="app" @onClose="closeReport" />
  </div>
</template>

<script>
export default {
  name: 'app-student-dgtreport-view',
  data () {
    return {
      show: false,
      student: {
        loading: false,
        data: {
          id: 0
        }
      },
      report: {
        loading: false,
        licenses: [],
        selected: {
          license: '',
          test: -1
        }
      },
      licensesWithoutCircuit: [
        'B'
      ]
    }
  },
  props: [
    'app'
  ],
  computed: {
    loading () {
      if (this.report.loading) {
        return true
      }

      return false
    },
    licenses () {
      let licenses = []

      for (let i in this.report.licenses) {
        licenses.push({
          value: this.report.licenses[i],
          name: this.app.strings.app.student.dgtreport.license.replace('{l}', this.report.licenses[i])
        })
      }

      return licenses
    },
    tests () {
      return [
        {
          value: 0,
          name: this.app.strings.app.student.dgtreport.tests.traffic
        },
        {
          value: 1,
          name: this.app.strings.app.student.dgtreport.tests.circuit
        }
      ]
    }
  },
  mounted () {
    this.student.data.code = this.$route.params.code

    this.show = true

    this.practiceReportLicenses()
  },
  methods: {
    practiceReportLicenses () {
      if (this.report.loading) {
        return
      }

      this.report.loading = true

      this.$http.get(
        this.app.url.api + this.app.endpoints.practice.report.licenses + '/' + this.student.data.code,
        {
          headers: {
            Authorization: 'Token ' + this.app.token
          }
        }
      ).then(response => {
        this.report.loading = false
        if (response.status === 200) {
          if (response.body.success === true) {
            this.report.licenses = response.body.data.licenses

            // With a single license there is nothing to choose.
            if (this.report.licenses.length === 1) {
              this.selectLicense(this.report.licenses[0])
            }
          } else {
            if (response.body.error.code === 'S100') {
              this.app.methods.logout()
            } else {
              this.showRequestError(this.app.strings, 'practice-report-licenses', response.body.error)
            }
          }
        } else {
          this.showError(this.app.strings, 'request', 'status-' + response.status)
        }
      }, () => {
        this.report.loading = false
        this.showError(this.app.strings, 'request', 'status-network: Connection unreachable')
      })
    },
    hasCircuit (license) {
      return !this.licensesWithoutCircuit.includes(license.toUpperCase())
    },
    selectLicense (license) {
      this.report.selected.license = license
      if (!this.hasCircuit(license)) {
        this.report.selected.test = 0
        this.openReport()
      }
    },
    openReport () {
      let strings = this.app.strings.app.student.dgtreport
      this.$refs['student-report'].open(
        this.app.url.api + '/practice/report/' + this.report.selected.license + '/' + this.report.selected.test + '/' + this.student.data.code + '?token=' + this.app.token,
        strings.title + ' · ' + strings.license.replace('{l}', this.report.selected.license)
      )
    },
    backToProfile () {
      this.$router.push({name: 'app.student.profile', params: {code: this.student.data.code}, query: {origin: 'app', navigationLeft: 'false', token: this.app.token}})
    },
    closeTests () {
      if (this.report.licenses.length === 1) {
        this.backToProfile()
      } else {
        this.report.selected.license = ''
      }
    },
    // From a report with a circuit, back to the choice of test.
    closeReport () {
      this.report.selected.test = -1
      if (!this.hasCircuit(this.report.selected.license)) {
        this.closeTests()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dgt-column {
  max-width: 640px;
  margin: 0 auto;
}

// The shared list goes in columns on desktop; here it follows this column.
.dgt-column ::v-deep .list > .list {
  display: block !important;
}

.dgt-empty {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px;
  border-radius: 16px;
  background-color: #FFFFFF;
  color: #64748b;
  font-size: 14px;
}

.dgt-empty > svg {
  flex: 0 0 auto;
  color: #94a3b8;
  font-size: 20px;
}

.dgt-hint {
  margin: 4px 4px 12px;
  color: #64748b;
  font-size: 14px;
}

.dgt-about {
  display: flex;
  gap: 14px;
  margin-top: 18px;
  padding: 16px 18px;
  border: 1px solid #e8edf3;
  border-radius: 18px;
  background-color: #FFFFFF;
  color: #475569;
  font-size: 14px;
  line-height: 1.5;
}

.dgt-about > svg {
  flex: 0 0 auto;
  margin-top: 2px;
  color: #2071b7;
  font-size: 22px;
}

.dgt-about b {
  color: #1f2a37;
  font-family: 'Lexend', sans-serif;
}

.dgt-about p {
  margin: 6px 0 0;
}

@import "@/assets/styles/variables.scss";
@import "@/assets/styles/variables-app.scss";
@import "@/assets/styles/variables-valkiria.scss";

#student-dgtreport-content {
  position: relative;
  width: 100%;
  min-height: 100%;
  padding: 72px 0 24px;
  box-sizing: border-box;
}


@media (min-width: 1024px) {
  #student-dgtreport-content {
    padding-top: 92px;
  }
}
</style>
